export default {"src":"/_next/static/media/NLY.a0be942a.svg","height":18,"width":18};